"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));
var _Tag = _interopRequireDefault(require("@airasia/phoenix-components/components/Tag"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));
var _constant = require("../constant");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _banner = _interopRequireDefault(require("./banner.proptypes"));
var _constant2 = require("./constant");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var BannerContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__BannerContainer",
  componentId: "sc-gqstd4-0"
})(["position:relative;min-height:", ";width:", ";height:", ";", " & > a{width:100%;height:100%;}", ""], _constant2.BANNER_MIN_HEIGHT, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.flexStyle && (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;"]);
}, function (props) {
  return props.hasClick && (0, _styledComponents.css)(["cursor:pointer;"]);
});
var ImageContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__ImageContainer",
  componentId: "sc-gqstd4-1"
})(["display:flex;height:100%;width:100%;& img{object-fit:cover !important;max-height:100%;max-width:100%;}"]);
var OverlayTextContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__OverlayTextContainer",
  componentId: "sc-gqstd4-2"
})(["position:absolute;z-index:100;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
var NewContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__NewContainer",
  componentId: "sc-gqstd4-3"
})(["width:330px;height:109px;position:relative;background-color:", ";padding:15px;display:flex;padding-bottom:", ";gap:16px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.semiSmall;
});
var SubContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__SubContainer",
  componentId: "sc-gqstd4-4"
})(["width:60%;height:109px;color:", ";font-size:", ";font-weight:", ";line-height:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyDark;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.XSmall;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.lineHeight.normal;
});
var SubImage = _styledComponents.default.div.withConfig({
  displayName: "Banner__SubImage",
  componentId: "sc-gqstd4-5"
})(["width:85px;height:85px;padding:", ";padding-left:", ";margin-left:", ";margin-top:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.XSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.tiny;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.normal;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.XXXSmall;
});
var AdditionalTag = _styledComponents.default.div.withConfig({
  displayName: "Banner__AdditionalTag",
  componentId: "sc-gqstd4-6"
})(["margin-bottom:9px;background-color:", ";padding:'1px' ", ";font-weight:", ";color:", ";border-radius:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.backgroundColor.redLight;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.micro;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontWeight.medium;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.primaryDark;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.borderRadius.normal;
});
var TextOverlay = _styledComponents.default.div.withConfig({
  displayName: "Banner__TextOverlay",
  componentId: "sc-gqstd4-7"
})(["color:white;"]);
var ImageOverlayContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__ImageOverlayContainer",
  componentId: "sc-gqstd4-8"
})(["width:100%;position:absolute;display:block;left:0;bottom:0;", " ", " ", " ", ""], function (props) {
  return props.overlayHeight ? (0, _styledComponents.css)(["height:", ";"], props.overlayHeight) : "\n        height: 50%;\n      ";
}, function (props) {
  return props.overlayBackground ? (0, _styledComponents.css)(["background:", ";"], props.overlayBackground) : "\n        background: linear-gradient(0deg, #000000 4.3%, rgba(0, 0, 0, 0) 96.12%);\n      ";
}, function (props) {
  return props.overlayZIndex ? (0, _styledComponents.css)(["z-index:", ";"], props.overlayZIndex) : "\n          z-index: 1;\n      ";
}, function (props) {
  return props.overlayOpacity ? (0, _styledComponents.css)(["opacity:", ";"], props.overlayOpacity) : "\n        opacity: 1;\n      ";
});
var getAlignSelf = function getAlignSelf(alignment) {
  switch (alignment) {
    case 'left':
    case 'top':
      return 'flex-start';
    case 'right':
    case 'bottom':
      return 'flex-end';
    case 'center':
      return 'center';
    default:
      return 'flex-start';
  }
};
var ButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__ButtonContainer",
  componentId: "sc-gqstd4-9"
})(["border:", ";box-sizing:border-box;border-radius:", ";padding:", " ", ";color:", ";background-color:", ";text-align:center;width:auto;margin-top:", ";align-self:", ";"], function (_ref16) {
  var buttonBorder = _ref16.buttonBorder,
    theme = _ref16.theme;
  return buttonBorder || "1px solid ".concat(theme.colors.greyLight);
}, function (_ref17) {
  var theme = _ref17.theme,
    buttonBorderRadius = _ref17.buttonBorderRadius;
  return theme.borderRadius[buttonBorderRadius] || theme.borderRadius.large;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.tiny;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.small;
}, function (_ref20) {
  var theme = _ref20.theme,
    buttonTextColor = _ref20.buttonTextColor;
  return buttonTextColor ? theme.colors[buttonTextColor] : theme.colors.neutral;
}, function (_ref21) {
  var theme = _ref21.theme,
    buttonBackgroundColor = _ref21.buttonBackgroundColor;
  return buttonBackgroundColor ? theme.colors[buttonBackgroundColor] : theme.colors.default;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return getAlignSelf(props.alignButtonContainer || props.alignHeadlineContainer);
});
var IconContainer = _styledComponents.default.span.withConfig({
  displayName: "Banner__IconContainer",
  componentId: "sc-gqstd4-10"
})(["margin-right:5px;"]);
var TitleContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__TitleContainer",
  componentId: "sc-gqstd4-11"
})(["position:absolute;z-index:2;display:flex;flex-direction:column;align-self:", ";justify-content:", ";height:100%;padding-left:5%;padding-right:", ";", " ", ""], function (props) {
  return getAlignSelf(props.alignHeadlineContainer);
}, function (props) {
  return getAlignSelf(props.alignHeadlineVerticalContainer);
}, function (props) {
  return props.newBanner ? '36%' : '5%';
}, function (props) {
  return props.alignHeadlineVerticalContainer === 'bottom' ? (0, _styledComponents.css)(["bottom:", ";"], props.headlineVerticalContainerBottomSpace) : "top: ".concat(props.headlineVerticalContainerTopSpace, ";");
}, function (props) {
  return props.titleContainerMaxWidth ? (0, _styledComponents.css)(["max-width:", ";"], props.titleContainerMaxWidth) : "";
});
var BackButton = _styledComponents.default.div.withConfig({
  displayName: "Banner__BackButton",
  componentId: "sc-gqstd4-12"
})(["position:absolute;top:", ";left:", ";z-index:10;color:", ";"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.small;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.small;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.default;
});
var TagContainer = _styledComponents.default.div.withConfig({
  displayName: "Banner__TagContainer",
  componentId: "sc-gqstd4-13"
})(["display:flex;flex-wrap:wrap;flex-direction:row;align-items:center;clear:both;margin-bottom:15px;"]);
var Banner = function Banner(props) {
  var imageURL = props.imageURL,
    placeHolderBackground = props.placeHolderBackground,
    hasOverlay = props.hasOverlay,
    additionalText = props.additionalText,
    overLayTag = props.overLayTag,
    altText = props.altText,
    headline = props.headline,
    subheadline = props.subheadline,
    tags = props.tags,
    tagTarget = props.tagTarget,
    showButton = props.showButton,
    buttonUrl = props.buttonUrl,
    buttonIcon = props.buttonIcon,
    buttonText = props.buttonText,
    buttonTextColor = props.buttonTextColor,
    buttonBackgroundColor = props.buttonBackgroundColor,
    buttonBorder = props.buttonBorder,
    buttonBorderRadius = props.buttonBorderRadius,
    buttonTarget = props.buttonTarget,
    alignButtonContainer = props.alignButtonContainer,
    onBannerClick = props.onBannerClick,
    redirectUrl = props.redirectUrl,
    redirectUrlTarget = props.redirectUrlTarget,
    queryParams = props.queryParams,
    width = props.width,
    height = props.height,
    headlineColor = props.headlineColor,
    subheadlineColor = props.subheadlineColor,
    alignHeadlineContainer = props.alignHeadlineContainer,
    alignHeadlineVerticalContainer = props.alignHeadlineVerticalContainer,
    headlineVerticalContainerTopSpace = props.headlineVerticalContainerTopSpace,
    headlineVerticalContainerBottomSpace = props.headlineVerticalContainerBottomSpace,
    titleContainerMaxWidth = props.titleContainerMaxWidth,
    accessibility = props.accessibility,
    customProperties = props.customProperties,
    device = props.device,
    theme = props.theme,
    lowResolutionImageUrl = props.lowResolutionImageUrl,
    gtmEventData = props.gtmEventData,
    fireGtm = props.fireGtm,
    enableProgressiveImageLoading = props.enableProgressiveImageLoading,
    showBackNavigation = props.showBackNavigation,
    backNavigationHandler = props.backNavigationHandler,
    idConfig = props.idConfig,
    lazyLoadImage = props.lazyLoadImage,
    isOnlyApplyForHotel = props.isOnlyApplyForHotel,
    newBanner = props.newBanner; // const { imageURL, altText, headline, subheadline, onBannerClick, redirectURL } = data;

  var accessible = accessibility;
  var customProps = customProperties;
  var tabIndex = !accessible.banner || redirectUrl ? '-1' : '0';
  var _ref25 = idConfig || {},
    parentName = _ref25.parentName,
    widgetName = _ref25.widgetName,
    index = _ref25.index;
  var _useState = (0, _react.useState)('banner'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dynamicID = _useState2[0],
    setId = _useState2[1];
  var createTags = function createTags(tagName, srcKey, srcValue) {
    if (typeof window !== 'undefined') {
      var preloadScript = document.createElement(tagName);
      preloadScript.setAttribute(srcKey, srcValue);
      preloadScript.setAttribute('rel', 'preload');
      preloadScript.setAttribute('as', 'style');
      document.head.appendChild(preloadScript);
    }
  };
  (0, _react.useEffect)(function () {
    if (index === 0) {
      createTags('link', 'href', lowResolutionImageUrl);
      createTags('link', 'href', imageURL);
    }
  }, [imageURL, index, lowResolutionImageUrl]);
  (0, _react.useEffect)(function () {
    var url = 'banner';
    if (parentName) {
      url = "".concat(parentName, "-banner");
    }
    if (index) {
      url += "-".concat(index);
    }
    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }
    setId(url);
  }, [widgetName, parentName, index]);
  function showBannerButton() {
    return buttonUrl && buttonText && (device === _constant.DEVICE_TYPE.DESKTOP || (device === _constant.DEVICE_TYPE.MOBILE || device === _constant.DEVICE_TYPE.TABLET) && showButton);
  }
  var onClickHandler = function onClickHandler(e) {
    if (!onBannerClick) {
      return;
    }
    onBannerClick(e, index, redirectUrl);
  };
  var imgComponent = function imgComponent() {
    return /*#__PURE__*/_react.default.createElement(ImageContainer, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      height: "100%",
      src: imageURL,
      alt: altText,
      width: "100%",
      accessible: false,
      theme: theme,
      lowResolutionImageUrl: lowResolutionImageUrl,
      enableProgressiveImageLoading: enableProgressiveImageLoading,
      lazyLoadImage: lazyLoadImage,
      placeHolderBackground: placeHolderBackground,
      customProperties: {
        'aria-hidden': true
      },
      parentName: "banner"
    }));
  };
  var tagComponent = function tagComponent() {
    if (tags) {
      return /*#__PURE__*/_react.default.createElement(TagContainer, null, tags &&
      // eslint-disable-next-line react/prop-types
      tags.map(function (tag) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: tag.label
        }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
          padding: newBanner ? '2px 4px' : null,
          type: "small",
          href: tag.url,
          target: tagTarget || 'self',
          color: tag.color,
          backgroundColor: tag.backgroundColor
        }, tag.label));
      }));
    }
    return null;
  };
  var buttonIconComponent = function buttonIconComponent() {
    return /*#__PURE__*/_react.default.createElement(IconContainer, null, buttonIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      icon: buttonIcon,
      color: buttonTextColor,
      fontsize: "titleSmall"
    }));
  };
  var titleComponent = function titleComponent() {
    return /*#__PURE__*/_react.default.createElement(TitleContainer, {
      alignHeadlineVerticalContainer: alignHeadlineVerticalContainer,
      headlineVerticalContainerTopSpace: headlineVerticalContainerTopSpace,
      headlineVerticalContainerBottomSpace: headlineVerticalContainerBottomSpace,
      titleContainerMaxWidth: titleContainerMaxWidth,
      newBanner: newBanner
    }, tags && tagComponent(), headline && /*#__PURE__*/_react.default.createElement(_Title.default, {
      type: newBanner ? 'h4' : 'heroBanner',
      marginBottom: subheadline ? 'micro' : null,
      color: headlineColor,
      accessible: accessible.headline,
      customProperties: customProps.headline,
      theme: theme
    }, headline), subheadline && /*#__PURE__*/_react.default.createElement(_Title.default, {
      type: newBanner ? 'p' : 'h3',
      color: subheadlineColor,
      accessible: accessible.subheadline,
      customProperties: customProps.subheadline,
      theme: theme
    }, subheadline), showBannerButton() && /*#__PURE__*/_react.default.createElement(ButtonContainer, {
      alignButtonContainer: alignButtonContainer,
      alignHeadlineContainer: alignHeadlineContainer,
      buttonBackgroundColor: buttonBackgroundColor,
      buttonBorder: buttonBorder,
      buttonBorderRadius: buttonBorderRadius
    }, buttonIcon && buttonIconComponent(), /*#__PURE__*/_react.default.createElement(_Link.default, {
      accessible: true,
      color: buttonTextColor || 'neutral',
      hoverUnderlined: false,
      href: buttonUrl,
      alignHeadlineContainer: alignHeadlineContainer,
      size: "normal",
      target: buttonTarget,
      theme: theme,
      idConfig: idConfig
    }, buttonText)));
  };
  var childrenComponents = function childrenComponents() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imgComponent(), (headline || subheadline) && titleComponent());
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, showBackNavigation && /*#__PURE__*/_react.default.createElement(BackButton, {
    onClick: function onClick() {
      return backNavigationHandler && backNavigationHandler();
    },
    id: dynamicID
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: isOnlyApplyForHotel && 'default',
    accessible: accessible.backNavigationIcon,
    icon: "ArrowBackIos",
    fontsize: "titleNormal"
  })), imageURL && !newBanner && /*#__PURE__*/_react.default.createElement(BannerContainer, (0, _extends2.default)({
    id: dynamicID,
    role: "application",
    width: width,
    height: height,
    tabIndex: tabIndex,
    hasClick: Boolean(onBannerClick),
    onClick: function onClick(e) {
      return onClickHandler(e);
    }
  }, customProps.banner), hasOverlay && /*#__PURE__*/_react.default.createElement(OverlayTextContainer, null, overLayTag && /*#__PURE__*/_react.default.createElement(AdditionalTag, null, overLayTag), additionalText && /*#__PURE__*/_react.default.createElement(TextOverlay, null, additionalText)), hasOverlay && /*#__PURE__*/_react.default.createElement(ImageOverlayContainer, customProps.overlay), redirectUrl && !newBanner && /*#__PURE__*/_react.default.createElement(_Link.default, {
    href: redirectUrl,
    target: redirectUrlTarget,
    queryParams: queryParams,
    alignHeadlineContainer: alignHeadlineContainer,
    gtmEventData: gtmEventData,
    fireGtm: fireGtm,
    accessible: accessible.banner,
    idConfig: idConfig
  }, childrenComponents()), !redirectUrl && childrenComponents()), newBanner && /*#__PURE__*/_react.default.createElement(NewContainer, null, /*#__PURE__*/_react.default.createElement(SubContainer, null, titleComponent()), /*#__PURE__*/_react.default.createElement(SubImage, null, imgComponent())));
};
Banner.propTypes = _banner.default.PropTypes;
Banner.defaultProps = _banner.default.DefaultProps;
var _default = Banner;
exports.default = _default;